/**
 * Backend role names emitted in the JWT `role` claim. Use these constants in
 * route `auth` arrays so a typo can't silently lock a role out of the app.
 */
export const ROLES = {
	Admin: 'Admin',
	HR: 'HR',
	Marketing: 'Marketing',
	Manager: 'Manager',
	Employee: 'Employee',
	RentalManager: 'RentalManager',
	RentalOperator: 'RentalOperator',
	AreaManager: 'AreaManager',
	AreaOperator: 'AreaOperator',
	LocationManager: 'LocationManager',
	Partner: 'Partner',
	PartnerAdmin: 'PartnerAdmin',
	Customer: 'Customer'
} as const;

export type RoleName = (typeof ROLES)[keyof typeof ROLES];

/**
 * Named role groupings used by route `auth` arrays. Keep these aligned with the
 * backend `FuseNavigation` config in appsettings.json.
 */
const authRoles = {
	admin: [ROLES.Admin] as RoleName[],
	staff: [
		ROLES.Admin,
		ROLES.HR,
		ROLES.Marketing,
		ROLES.Manager,
		ROLES.Employee
	] as RoleName[],
	partnerFamily: [ROLES.Partner, ROLES.PartnerAdmin] as RoleName[],
	partnerAdmin: [ROLES.PartnerAdmin] as RoleName[],
	onlyGuest: [] as RoleName[]
};

export default authRoles;
